var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDownLeft = function SvgArrowDownLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.814 10.75a.56.56 0 0 1-.563-.562V4.563c0-.312.25-.562.563-.562.311 0 .562.25.562.562v4.268L9.79 3.415a.562.562 0 0 1 .795.795L5.17 9.622l4.268.003a.561.561 0 1 1 0 1.125z"
  })));
};
export default SvgArrowDownLeft;